<template>
  <div id="chair_man" :style="{backgroundImage: `url(${require('@/statics/img/about/bg.webp')})`}">
    <div class="title w1200 page_header_space">
      <h3 class="txt-bold">理事長的話</h3>
      <img src="@/statics/img/index/icon_title2.svg" alt="">
    </div>

    <img class="bg_heart" src="@/statics/img/about/bg_heart.webp" alt="">

    <div class="content w1200">
      <div class="col50">
        <h2 class="title">迎接2030高齡社會 居家醫療成為長照與醫療重要支柱</h2>
        <div class="desc">
          <p v-for="(text, i) in paragraphs" :key="i">{{ text }}</p>
        </div>
      </div>

      <div class="col50">
        <div class="img_wrap">
          <img class="hands" src="@/statics/img/about/img_1.webp" alt="">
          <img class="sign" src="@/statics/img/about/img_2.png" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AboutChairman',
  data() {
    return {
      paragraphs: [
        '台灣居家醫療醫學會理事長趙榮勤醫師強調，隨著台灣人口快速高齡化，預估2030年將'
      + '面臨更明顯的人口老化與長期照顧需求。高齡人口增加的同時，臥床、失能、行動不便及罹'
      + '患多重慢性疾病的長輩也將持續增加，傳統以醫院及診所為中心的醫療模式，已難以完全滿'
      + '足未來高齡社會的需求，「醫療走進家庭」將成為重要發展方向。',
        '趙榮勤理事長表示，對於長期臥床、失能、失智、慢性病、多重疾病或行動不便的長輩而言'
      + '，就醫往往需要家屬陪同、交通接送，甚至仰賴救護車，不僅增加家庭照顧負擔，也可能因'
      + '就醫不便而延誤醫療。居家醫療可以由醫師、護理師、藥師、社工及相關專業人員組成團隊'
      + '，將醫療服務延伸到病人的生活場域，提供疾病評估、慢性病控制、用藥管理、傷口照護、'
      + '復健及安寧緩和醫療等服務。',
        '他進一步指出，未來居家醫療不應只是「到家裡看診」，而應逐步發展成以病人及家庭為中'
      + '心的整合照護模式，結合長照、社區醫療、急性醫療及安寧照護，建立醫療與照顧之間的連'
      + '續性。尤其對偏鄉及醫療資源不足地區，更應透過遠距醫療、跨專業團隊及在宅急症照護，'
      + '讓長輩能在熟悉的家中獲得適切醫療。',
        '趙榮勤理事長強調，面對2030年高齡社會的挑戰，台灣必須及早布局居家醫療人才培訓'
      + '、支付制度及跨領域整合，讓「在家也能獲得安全、專業、有品質的醫療」成為全民都能享'
      + '有的照護選擇。未來居家醫療將不只是高齡照護的一環，更是台灣醫療體系邁向以人為本、'
      + '社區化及永續發展的重要關鍵。',
      ],
    };
  },
};
</script>
